export default "__VITE_ASSET__5e043a2b__"